import {LOCAL_AUTH_STORAGE_KEY} from './constants';
import localforage from 'localforage';
import {isEmpty} from 'lodash';

export const getLocalAuth = async () => {
  const auth: any = await localforage.getItem(LOCAL_AUTH_STORAGE_KEY);

  if (!isEmpty(auth?.user?.email)) {
    return auth;
  } else {
    return null;
  }
};

export const removeLocalAuth = async () => {
  await localforage.removeItem(LOCAL_AUTH_STORAGE_KEY);
  return true;
};

export const addLocalAuth = async (auth: any) => {
  await localforage.setItem(LOCAL_AUTH_STORAGE_KEY, auth);
  return auth;
};

export const addUserProfileToLocalAuth = async (userProfile: any) => {
  const localAuth: any = await localforage.getItem(LOCAL_AUTH_STORAGE_KEY);
  localAuth.user = {...userProfile};
  await localforage.setItem(
    LOCAL_AUTH_STORAGE_KEY,
    localAuth,
  );

  return userProfile;
};
